<template>
  <div id="app" :class="{ home: isHome, page: !isHome }">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isHome: true
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'Home') {
        this.isHome = true
      } else {
        this.isHome = false
      }
    }
  },
  created() {
    // 获取项目配置
    this.$store.dispatch('FetchConfig')
    this.$store.dispatch('FetchCategory')
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0px;
  padding: 0px;
  border: none;
  background-size: 100% 100%;
}

.home {
  background: url(./assets/imgs/sy-bg.jpg) no-repeat;
}
.page {
  background: url(./assets/imgs/page-bg.jpg) no-repeat;
}
</style>
